import { useContext } from 'react';
import UserContext from 'src/contexts/UserContext/UserContext';

const useUser = () => {
  return useContext(UserContext);
};

export default useUser;
